import { Store } from "@tanstack/react-store";

/** Cursor's built-in browser: Firebase Auth emulator redirect email, before route guards. */
export const authRedirectEmailStore = new Store<string | null>(null);

export function publishAuthRedirectEmail(email: string): void {
  authRedirectEmailStore.setState(() => email);
}
